/***************************************************************************************************/
/*                                 Env & Tools                                                     */
/***************************************************************************************************/
// tslint:disable:max-line-length
import { TCITenantAppType } from "./tci-application";
import * as lodash from "lodash";
import {
    AbstractTCITenantComponentOptions,
    ITCIOptionType,
    ITCITenantComponentOptions, ITCITenantModalOptions, ITCITenantModalType, TCITenantModalType,
    TCITenantSelectorType
} from "./tci-tenant";
import { strEnum } from "../../types";

export const TCI_TOOLS_ENV_TYPE: ITCIOptionType<string> = {
    ENV_SETTINGS: "Environment Settings",
    EXTN_MANAGEMENT: "Connector Management & Extensions",
    DOWNLOADS: "Tool Downloads"
};
export type TCI_TOOLS_ENV_TYPE = keyof typeof TCI_TOOLS_ENV_TYPE | string;

/**
 * class TCITenantEnvToolsMenu
 */
export class TCITenantEnvTools extends AbstractTCITenantComponentOptions<TCI_TOOLS_ENV_TYPE> implements ITCITenantComponentOptions<TCI_TOOLS_ENV_TYPE> {
    public static TCI_ENV_TOOLS_AGENTS = new TCITenantEnvTools("Agents", TCITenantSelectorType.TCI_ENV_TOOLS_AGENTS, 1, TCI_TOOLS_ENV_TYPE.ENV_SETTINGS, "agents", [
        TCITenantAppType.scribe,
        TCITenantAppType.node,
        TCITenantAppType.flogo,
        TCITenantAppType.bw
    ], null);
    public static TCI_ENV_TOOLS_LOOKUP_TABLES = new TCITenantEnvTools("Lookup Tables", TCITenantSelectorType.TCI_ENV_TOOLS_LOOKUP_TABLES, 3, TCI_TOOLS_ENV_TYPE.ENV_SETTINGS, "scribe_lookuptables", [
        TCITenantAppType.scribe
    ], null);
    public static TCI_ENV_TOOLS_SECURITY_SETTINGS = new TCITenantEnvTools("Security Settings", TCITenantSelectorType.TCI_ENV_TOOLS_SECURITY_SETTINGS, 5, TCI_TOOLS_ENV_TYPE.ENV_SETTINGS, "scribe_security", [
        TCITenantAppType.scribe
    ], null);
    public static TCI_ENV_TOOLS_NOTIFICATIONS = new TCITenantEnvTools("Notifications", TCITenantSelectorType.TCI_ENV_TOOLS_NOTIFICATIONS, 4, TCI_TOOLS_ENV_TYPE.ENV_SETTINGS, "scribe_notifications", [
        TCITenantAppType.scribe
    ], null);
    public static TCI_ENV_TOOLS_VPN_CONNECTIONS = new TCITenantEnvTools("VPN Connections", TCITenantSelectorType.TCI_ENV_TOOLS_VPN_CONNECTIONS, 5, TCI_TOOLS_ENV_TYPE.ENV_SETTINGS, "vpnconnections", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw,
        TCITenantAppType.node,
        TCITenantAppType.mg,
    ], null);
    public static TCI_ENV_TOOLS_AUTOMATE_ADMINISTRATION = new TCITenantEnvTools("Automate administration", TCITenantSelectorType.TCI_ENV_TOOLS_AUTOMATE_ADMINISTRATION, 7, TCI_TOOLS_ENV_TYPE.ENV_SETTINGS, "automate_administration", [
        TCITenantAppType.liveapps
    ], "/api/v1/liveappsui/apps/admin-app/index.html?Mode=TCI");
    public static TCI_ENV_TOOLS_HYBRID_CONNECTION = new TCITenantEnvTools("Hybrid Connection", TCITenantSelectorType.TCI_ENV_TOOLS_HYBRID_CONNECTION, 2, TCI_TOOLS_ENV_TYPE.ENV_SETTINGS, "hybrid_connection", [
        TCITenantAppType.flogo,
        // TCITenantAppType.node // IPAS-16518
    ], null);
    public static TCI_ENV_TOOLS_ALERT = new TCITenantEnvTools("Alerts", TCITenantSelectorType.TCI_ENV_TOOLS_ALERT, 8, TCI_TOOLS_ENV_TYPE.ENV_SETTINGS, "env_alerts", [
        // Note: enable node app and disable flogo/bw app for testing only.
        // TCITenantAppType.node,
        TCITenantAppType.flogo,
        TCITenantAppType.bw
    ], null);
    public static TCI_ENV_TOOLS_MANAGED_CONNECTORS = new TCITenantEnvTools("Managed Connectors", TCITenantSelectorType.TCI_ENV_TOOLS_MANAGED_CONNECTORS, 3, TCI_TOOLS_ENV_TYPE.EXTN_MANAGEMENT, "scribe_managed_connectors", [
        TCITenantAppType.scribe
    ], null);
    public static TCI_ENV_TOOLS_EXTENSIONS = new TCITenantEnvTools("Extensions", TCITenantSelectorType.TCI_ENV_TOOLS_EXTENSIONS, 2, TCI_TOOLS_ENV_TYPE.EXTN_MANAGEMENT, "flogo_extensions", [
        TCITenantAppType.flogo
    ], null);
    public static TCI_ENV_TOOLS_SUPPLEMENTS = new TCITenantEnvTools("Supplements", TCITenantSelectorType.TCI_ENV_TOOLS_SUPPLEMENTS, 1, TCI_TOOLS_ENV_TYPE.EXTN_MANAGEMENT, "supplements", [
        TCITenantAppType.flogo,
        TCITenantAppType.bw
    ], null);
    public static TCI_ENV_TOOLS_DLD_TIBCLI = new TCITenantEnvTools("TIBCO&reg; Cloud - Command Line Interface", TCITenantSelectorType.TCI_ENV_TOOLS_DLD_TIBCLI, 1, TCI_TOOLS_ENV_TYPE.DOWNLOADS, "download_tibcli", [
        TCITenantAppType.bw,
        TCITenantAppType.flogo,
        TCITenantAppType.node,
    ], null);
    public static TCI_ENV_TOOLS_DLD_BW = new TCITenantEnvTools("TIBCO Business Studio for BusinessWorks &trade;", TCITenantSelectorType.TCI_ENV_TOOLS_DLD_BW, 2, TCI_TOOLS_ENV_TYPE.DOWNLOADS, "download_bw", [
        TCITenantAppType.bw
    ], null);
    public static TCI_ENV_TOOLS_DLD_DRIVERS = new TCITenantEnvTools("Drivers", TCITenantSelectorType.TCI_ENV_TOOLS_DLD_DRIVERS, 3, TCI_TOOLS_ENV_TYPE.DOWNLOADS, "download_scribe_drivers", [
        TCITenantAppType.scribe
    ], null);
    public static TCI_ENV_TOOLS_DLD_AGENTS = new TCITenantEnvTools("Agents Download", TCITenantSelectorType.TCI_ENV_TOOLS_DLD_AGENTS, 4, TCI_TOOLS_ENV_TYPE.DOWNLOADS, "download_scribe_agents", [
        TCITenantAppType.scribe
    ], null);

    private static allItems = [
        TCITenantEnvTools.TCI_ENV_TOOLS_AGENTS,
        TCITenantEnvTools.TCI_ENV_TOOLS_HYBRID_CONNECTION,
        TCITenantEnvTools.TCI_ENV_TOOLS_LOOKUP_TABLES,
        TCITenantEnvTools.TCI_ENV_TOOLS_SECURITY_SETTINGS,
        TCITenantEnvTools.TCI_ENV_TOOLS_NOTIFICATIONS,
        TCITenantEnvTools.TCI_ENV_TOOLS_VPN_CONNECTIONS,
        TCITenantEnvTools.TCI_ENV_TOOLS_ALERT,
        TCITenantEnvTools.TCI_ENV_TOOLS_MANAGED_CONNECTORS,
        TCITenantEnvTools.TCI_ENV_TOOLS_SUPPLEMENTS,
        TCITenantEnvTools.TCI_ENV_TOOLS_EXTENSIONS,
        TCITenantEnvTools.TCI_ENV_TOOLS_DLD_TIBCLI,
        TCITenantEnvTools.TCI_ENV_TOOLS_DLD_BW,
        TCITenantEnvTools.TCI_ENV_TOOLS_DLD_DRIVERS,
        TCITenantEnvTools.TCI_ENV_TOOLS_AUTOMATE_ADMINISTRATION,
        // TCITenantEnvTools.TCI_ENV_TOOLS_DLD_AGENTS,
    ];

    /**
     * Gets All items
     * @param toolType
     * @return @ITCITenantEnvTools[]
     */
    public static getAllItems(toolType?: TCI_TOOLS_ENV_TYPE): ITCITenantComponentOptions<TCI_TOOLS_ENV_TYPE>[] {
        if (toolType) {
            return TCITenantEnvTools.allItems.filter((v) => {
                return v.getOptionType() === toolType;
            });
        }
        return TCITenantEnvTools.allItems;
    }

    /**
     * constructor
     * @param menuOption
     * @param componentSelectorType
     * @param position
     * @param toolType
     * @param routeId
     * @param tenantAppTypes
     * @param externalUrl
     */
    constructor(menuOption: string,
                componentSelectorType: TCITenantSelectorType,
                position: number,
                toolType: TCI_TOOLS_ENV_TYPE,
                routeId: string,
                tenantAppTypes: TCITenantAppType[],
                externalUrl: string) {
        super(menuOption, componentSelectorType, position, toolType, routeId, tenantAppTypes, externalUrl);
    }

    equals(that): boolean {
        // Shortcut for trivial case
        if (this === that) {
            return true;
        }

        // If the that object is not a set, it is not equal to this one.
        // We use instanceof to allow any subclass of Set.
        // We could relax this test if we wanted true duck-typing.
        // Or we could strengthen it to check this.constructor == that.constructor // Note that instanceof properly rejects null and undefined values
        if (!(that instanceof TCITenantEnvTools)) {
            return false;
        }

        return lodash.isEqual(this, that);
    }
}

export const TCI_AGENT_TYPE: ITCIOptionType<string> = {
    AGENT_TYPE_HYBRID: "Hybrid",
    AGENT_TYPE_CONNECT: "Connect"
};

/**
 * class TCITenantEnvToolsAgentsCreate Menu
 */
export class TCITenantEnvToolsAgents
    extends AbstractTCITenantComponentOptions<TCI_AGENT_TYPE>
    implements ITCITenantComponentOptions<TCI_AGENT_TYPE>, ITCITenantModalOptions {
    public static TCI_ENV_TOOLS_AGENT_CONNECT = new TCITenantEnvToolsAgents(
        "Connect",
        TCITenantSelectorType.TCI_ENV_TOOLS_AGENTS_LIST,
        1,
        TCI_AGENT_TYPE.AGENT_TYPE_CONNECT,
        "tool_agents_connect",
        [
            TCITenantAppType.scribe
        ]);
    public static TCI_ENV_TOOLS_AGENT_HYBRID = new TCITenantEnvToolsAgents(
        "Hybrid",
        TCITenantSelectorType.TCI_ENV_TOOLS_AGENTS_LIST,
        2,
        TCI_AGENT_TYPE.AGENT_TYPE_HYBRID,
        "tool_agents_hybrid",
        [
            TCITenantAppType.flogo,
            TCITenantAppType.bw,
            TCITenantAppType.node
        ]);


    private static allItems = [
        TCITenantEnvToolsAgents.TCI_ENV_TOOLS_AGENT_CONNECT,
        TCITenantEnvToolsAgents.TCI_ENV_TOOLS_AGENT_HYBRID,
    ];

    /**
     * Gets All items
     * @param toolType
     * @return @TCITenantEnvToolsAgents[]
     */
    public static getAllMenuItems(toolType?: TCI_AGENT_TYPE): ITCITenantComponentOptions<TCI_AGENT_TYPE>[] {
        if (toolType) {
            return TCITenantEnvToolsAgents.allItems.filter((v) => {
                return v.getOptionType() === toolType;
            });
        }
        return TCITenantEnvToolsAgents.allItems;
    }

    /**
     * constructor
     * @param menuOption
     * @param componentSelectorType
     * @param position
     * @param toolType
     * @param routeId
     * @param tenantAppTypes
     * @param modalType
     */
    private constructor(menuOption: string,
        componentSelectorType: TCITenantSelectorType,
        position: number,
        toolType: TCI_TOOLS_ENV_TYPE,
        routeId: string,
        tenantAppTypes: TCITenantAppType[],
        private modalType: ITCITenantModalType = TCITenantModalType.TCI_MODAL_MEDIUM) {
        super(menuOption, componentSelectorType, position, toolType, routeId, tenantAppTypes, null);
    }

    getModalType(): ITCITenantModalType {
        return this.modalType;
    }

    equals(that): boolean {
        // Shortcut for trivial case
        if (this === that) {
            return true;
        }

        // If the that object is not a set, it is not equal to this one.
        // We use instanceof to allow any subclass of Set.
        // We could relax this test if we wanted true duck-typing.
        // Or we could strengthen it to check this.constructor == that.constructor // Note that instanceof properly rejects null and undefined values
        if (!(that instanceof TCITenantEnvTools)) {
            return false;
        }

        return lodash.isEqual(this, that);
    }
}

export type TCI_AGENT_TYPE = keyof typeof TCI_AGENT_TYPE | string;

export const TCI_AGENT_CREATE_TYPE: ITCIOptionType<string> = {
    AGENT_CREATE_TYPE_HYBRID: "Hybrid",
    AGENT_CREATE_TYPE_CONNECT_CLOUD: "Connect Cloud",
    AGENT_CREATE_TYPE_CONNECT_ON_PREM: "Connect On Premise",
    AGENT_CREATE_TYPE_UNIFIED_MGMT: "Unified Management",
};

export type TCI_AGENT_CREATE_TYPE = keyof typeof TCI_AGENT_CREATE_TYPE | string;


/**
 * class TCITenantEnvToolsAgentsCreate Menu
 */
export class TCITenantEnvToolsAgentsCreate
    extends AbstractTCITenantComponentOptions<TCI_AGENT_CREATE_TYPE>
    implements ITCITenantComponentOptions<TCI_AGENT_CREATE_TYPE>, ITCITenantModalOptions {
    public static TCI_ENV_TOOLS_AGENT_CONNECT_CLOUD = new TCITenantEnvToolsAgentsCreate(
        "Connect Cloud",
        TCITenantSelectorType.TCI_ENV_TOOLS_AGENT_CONNECT_CLOUD,
        1,
        TCI_AGENT_CREATE_TYPE.AGENT_CREATE_TYPE_CONNECT_CLOUD,
        "tool_agents_connect_cloud",
        [
            TCITenantAppType.scribe
        ],
        TCITenantModalType.TCI_MODAL_INLINE);
    public static TCI_ENV_TOOLS_AGENT_CONNECT_ON_PREM = new TCITenantEnvToolsAgentsCreate(
        "Connect On-Premise",
        TCITenantSelectorType.TCI_ENV_TOOLS_AGENT_CONNECT_ON_PREM,
        2,
        TCI_AGENT_CREATE_TYPE.AGENT_CREATE_TYPE_CONNECT_ON_PREM,
        "tool_agents_connect_on_premise",
        [
            TCITenantAppType.scribe
        ],
        TCITenantModalType.TCI_MODAL_SMALL);
    public static TCI_ENV_TOOLS_AGENT_HYBRID = new TCITenantEnvToolsAgentsCreate(
        "Hybrid",
        TCITenantSelectorType.TCI_ENV_TOOLS_AGENT_HYBRID,
        3,
        TCI_AGENT_CREATE_TYPE.AGENT_CREATE_TYPE_HYBRID,
        "tool_agents_hybrid",
        [
            TCITenantAppType.bw,
            TCITenantAppType.node,
            TCITenantAppType.flogo
        ],
        TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_ENV_TOOLS_AGENT_UNIFIED_MGMT = new TCITenantEnvToolsAgentsCreate(
        "Unified Management",
        TCITenantSelectorType.TCI_ENV_TOOLS_AGENT_UNIFIED_MGMT,
        4,
        TCI_AGENT_CREATE_TYPE.AGENT_CREATE_TYPE_UNIFIED_MGMT,
        "tool_agents_unified_management",
        [
            TCITenantAppType.bw,
            TCITenantAppType.flogo
        ],
        TCITenantModalType.TCI_MODAL_MEDIUM);


    private static allItems = [
        TCITenantEnvToolsAgentsCreate.TCI_ENV_TOOLS_AGENT_CONNECT_CLOUD,
        TCITenantEnvToolsAgentsCreate.TCI_ENV_TOOLS_AGENT_CONNECT_ON_PREM,
        TCITenantEnvToolsAgentsCreate.TCI_ENV_TOOLS_AGENT_HYBRID
        // TCITenantEnvToolsAgentsCreate.TCI_ENV_TOOLS_AGENT_UNIFIED_MGMT
    ];

    /**
     * Gets All items
     * @param toolType
     * @return @TCITenantEnvToolsAgents[]
     */
    public static getAllMenuItems(toolType?: TCI_AGENT_CREATE_TYPE): ITCITenantComponentOptions<TCI_AGENT_CREATE_TYPE>[] {
        if (toolType) {
            return TCITenantEnvToolsAgentsCreate.allItems.filter((v) => {
                return v.getOptionType() === toolType;
            });
        }
        return TCITenantEnvToolsAgentsCreate.allItems;
    }

    /**
     * constructor
     * @param menuOption
     * @param componentSelectorType
     * @param position
     * @param toolType
     * @param routeId
     * @param tenantAppTypes
     * @param modalType
     */
    private constructor(menuOption: string,
        componentSelectorType: TCITenantSelectorType,
        position: number,
        toolType: TCI_TOOLS_ENV_TYPE,
        routeId: string,
        tenantAppTypes: TCITenantAppType[],
        private modalType: ITCITenantModalType = TCITenantModalType.TCI_MODAL_SMALL) {
        super(menuOption, componentSelectorType, position, toolType, routeId, tenantAppTypes, null);
    }

    getModalType(): ITCITenantModalType {
        return this.modalType;
    }

    equals(that): boolean {
        // Shortcut for trivial case
        if (this === that) {
            return true;
        }

        // If the that object is not a set, it is not equal to this one.
        // We use instanceof to allow any subclass of Set.
        // We could relax this test if we wanted true duck-typing.
        // Or we could strengthen it to check this.constructor == that.constructor // Note that instanceof properly rejects null and undefined values
        if (!(that instanceof TCITenantEnvTools)) {
            return false;
        }

        return lodash.isEqual(this, that);
    }
}
export interface ITCIHybridDbConnection {
    subId: string;
    status: string;
    accessKey: string;
}

export interface ITCIFlogoTesterService {
    subId: string;
    status: string;
    accessKey: string;
}

export const TCIToolDownloadType = strEnum(["cli", "hybridAgent", "agent_ext"]);
export type TCIToolDownloadType = keyof typeof TCIToolDownloadType;


export const TCI_SUPPLEMENT_MENU_TYPE: ITCIOptionType<string> = {
    SUPPLEMENT_EDIT: "Edit",
    SUPPLEMENT_DOWNLOAD: "Download"
};

export type TCI_SUPPLEMENT_MENU_TYPE = keyof typeof TCI_SUPPLEMENT_MENU_TYPE | string;

/**
 * class TCITenantEnvToolsAgentsCreate Menu
 */
export class TCITenantEnvToolsSupplements
    extends AbstractTCITenantComponentOptions<TCI_SUPPLEMENT_MENU_TYPE>
    implements ITCITenantComponentOptions<TCI_SUPPLEMENT_MENU_TYPE>, ITCITenantModalOptions {
    public static TCI_ENV_TOOLS_SUPPLEMENTS_EDIT = new TCITenantEnvToolsSupplements(
        "Edit",
        TCITenantSelectorType.TCI_ENV_TOOLS_SUPPLEMENTS_EDIT,
        1,
        TCI_SUPPLEMENT_MENU_TYPE.SUPPLEMENT_EDIT,
        "tool_supplement_edit",
        [
            TCITenantAppType.flogo,
            TCITenantAppType.bw
        ],
        TCITenantModalType.TCI_MODAL_MEDIUM);
    public static TCI_ENV_TOOLS_SUPPLEMENTS_DOWNLOAD = new TCITenantEnvToolsSupplements(
        "Download",
        TCITenantSelectorType.TCI_ENV_TOOLS_SUPPLEMENTS_DOWNLOAD,
        2,
        TCI_SUPPLEMENT_MENU_TYPE.SUPPLEMENT_DOWNLOAD,
        "tool_supplement_download",
        [
            TCITenantAppType.flogo,
            TCITenantAppType.bw
        ],
        TCITenantModalType.TCI_MODAL_INLINE);


    private static allItems = [
        TCITenantEnvToolsSupplements.TCI_ENV_TOOLS_SUPPLEMENTS_EDIT,
        TCITenantEnvToolsSupplements.TCI_ENV_TOOLS_SUPPLEMENTS_DOWNLOAD,
    ];

    /**
     * Gets All items
     * @param toolType
     * @return @TCITenantEnvToolsAgents[]
     */
    public static getAllMenuItems(toolType?: TCI_SUPPLEMENT_MENU_TYPE): ITCITenantComponentOptions<TCI_SUPPLEMENT_MENU_TYPE>[] {
        if (toolType) {
            return TCITenantEnvToolsSupplements.allItems.filter((v) => {
                return v.getOptionType() === toolType;
            });
        }
        return TCITenantEnvToolsSupplements.allItems;
    }

    /**
     * constructor
     * @param menuOption
     * @param componentSelectorType
     * @param position
     * @param toolType
     * @param routeId
     * @param tenantAppTypes
     * @param modalType
     */
    private constructor(menuOption: string,
        componentSelectorType: TCITenantSelectorType,
        position: number,
        toolType: TCI_SUPPLEMENT_MENU_TYPE,
        routeId: string,
        tenantAppTypes: TCITenantAppType[],
        private modalType: ITCITenantModalType = TCITenantModalType.TCI_MODAL_MEDIUM) {
        super(menuOption, componentSelectorType, position, toolType, routeId, tenantAppTypes, null);
    }

    getModalType(): ITCITenantModalType {
        return this.modalType;
    }

    equals(that): boolean {
        // Shortcut for trivial case
        if (this === that) {
            return true;
        }

        // If the that object is not a set, it is not equal to this one.
        // We use instanceof to allow any subclass of Set.
        // We could relax this test if we wanted true duck-typing.
        // Or we could strengthen it to check this.constructor == that.constructor // Note that instanceof properly rejects null and undefined values
        if (!(that instanceof TCITenantEnvTools)) {
            return false;
        }

        return lodash.isEqual(this, that);
    }
}


